module.exports = __webpack_public_path__ + "static/media/camera-polaroid.635aa74a.svg";